import { Boxes, PriceDVGT, Shipment,PromotionPriceViewModel } from "../models";

export class ShipmentCalculateViewModel {
    disCount: number;
    priceListId: number;
    priceServiceId: number;
    orderDate: any;
    fromHubId: number;
    toHubId:number;
    senderId: number;
    senderPhone: string;
    fromDistrictId: number;
    fromWardId: number;
    toDistrictId: number;
    weight: number;
    serviceId: number;
    paymentTypeId: number;
    structureId: number;
    cod: number;
    insured: number;
    otherPrice: number;
    serviceDVGTIds: number[];
    isAgreementPrice: boolean;
    defaultPrice: number;
    totalItemOld: number;
    totalItem: number;
    calWeight: number;
    toWardId: number;
    priceBox: Shipment[];
    priceDVGTs: PriceDVGT[];
    priceReturn: number;
    distance: number;
    totalBox: number;
    transferVehicleId: number;
    pickupVehicleId: number;
    deliveryVehicleId: number;
    numberOfDeliveries: number = 1;
    listBoxs: Shipment[] = [];
    promotions: PromotionPriceViewModel[] = [];
    isReturn: boolean;
    fromProvinceId: any;
    length: number;
    width: number;
    height: number;
    promotionCode:string="";
    shipmentId:number;
    deposits:number;
    isNotRound?:boolean;
}